import type {
  ActiveMembershipIdsType,
  ActiveVariantIdsType
} from "@membership/constants";
import { activeMemberships, activeVariants } from "@membership/constants";
import type { ContextHeaderType, AppContextType } from "@shared/graphql.apollo";

export const defaultContext = {
  backend: "ct" as const,
  locale: "en-GB" as const,
  storeid: "uk" as const,
  region: "uk" as const,
  currencySymbol: "£" as const,
  membershipIds: activeMemberships["en-GB"] as ActiveMembershipIdsType,
  variantIds: activeVariants["en-GB"] as ActiveVariantIdsType,
  currency: "GBP" as const,
  store: "en" as const
};

export const toAppContext = (headers: ContextHeaderType): AppContextType => {
  const membershipIds: ActiveMembershipIdsType =
    activeMemberships[headers.locale];
  const variantIds: ActiveVariantIdsType = activeVariants[headers.locale];

  if (headers.locale === "en-GB") {
    return {
      ...headers,
      membershipIds,
      variantIds,
      region: "uk",
      currencySymbol: "£",
      currency: "GBP",
      store: "en"
    };
  }

  if (headers.locale === "en-US") {
    return {
      ...headers,
      membershipIds,
      variantIds,
      region: "us",
      currencySymbol: "$",
      currency: "USD",
      store: "us"
    };
  }

  return defaultContext;
};
